
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M11 1.294l11 18.765H0L11 1.294zm0 3.714L3.278 18.181h15.444L11 5.008z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M10.03 14.58V8.874h1.94v5.704h-1.94zM10.03 17.131v-1.35h1.94v1.35h-1.94z"}})])
          )
        }
      }
    